import { useRef } from "react";
import { GpsDeviceFormModal } from "@/modules/gps-devices/components/GpsDeviceFormModal";
import { GpsDeviceTable } from "@/modules/gps-devices/components/GpsDeviceTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

interface OrgGpsDevicesTabProps {
	organizationId: string;
}

export function OrgGpsDevicesTab({ organizationId }: OrgGpsDevicesTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "gps" });
	// GpsDeviceTable fires onPageChange then onLimitChange in the same
	// pagination event; buffer the page so both land in one URL update.
	const pendingPageRef = useRef(page);

	return (
		<>
			<GpsDeviceTable
				organizationId={organizationId}
				page={page}
				limit={limit}
				onPageChange={(nextPage) => {
					pendingPageRef.current = nextPage;
				}}
				onLimitChange={(nextLimit) => setPage(pendingPageRef.current, nextLimit)}
			/>
			<GpsDeviceFormModal organizationId={organizationId} />
		</>
	);
}
